import { useSession } from "providers/SessionProvider";
import React, { PropsWithChildren, useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router";
import { RootPaths } from "routes/RootRouter";
import { AuthService } from "services/authService";
import { SessionService } from "services/sessionService";
import { SplashScreen } from "views/SplashScreen";

export const RequireAuth: React.FC<PropsWithChildren> = ({ children }) => {
    const location = useLocation();
    const { isAuthenticated, isTwoFactorPassed } = useSession();
    const [checked, setChecked] = useState(AuthService.accessChecked);
    const [auth, setAuth] = useState(isAuthenticated);

    useEffect(() => {
        async function checkAccess() {
            var continueAuth = await AuthService.IsUserYetAuthenticated();
            if (!continueAuth) setAuth(false);
            else SessionService.current.clearCarouselData();

            setChecked(continueAuth);
        }

        if (!checked && isAuthenticated) checkAccess();
    }, []);

    // Ao redirecionar para a página /login,  salva a localização atual de quem está chamando.
    // Isto permite redirecionar para a página original após o login.

    return !isAuthenticated || !isTwoFactorPassed
        ? <Navigate to={RootPaths.Login} state={{ from: location }} />
        : !auth
            ? <Navigate to={RootPaths.LoginExpired} state={{ from: location }} />
            : checked
                ? children
                : <SplashScreen mode="checkAccess" lastError={null} />;
};
